import { Component, ViewChild } from '@angular/core';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
	selector: 'pdf-modal',
	template: require('./pdf-modal.template.html')
})

export class PdfModalComponent {
	constructor(private sanitizer: DomSanitizer) { }

	@ViewChild('modal') childModal: ModalDirective;

	title: string;
	pdfUrl: SafeResourceUrl;

	show(title: string, pdfUrl: string): void {
		this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
		this.title = title;
		this.childModal.show();
	}

	onHidden(event) {
		this.pdfUrl = null;
		this.title = null;
	}

	onHide(event): void {
		this.childModal.hide();
	}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/components/pdf-modal.component.ts